import React from "react"
import { Link } from "react-router-dom"
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
} from "react-icons/fa"

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-[#111111] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <Link
              to="/"
              className="inline-block mb-5"
              aria-label="Centre SpaLand Saphir Palace & Hammamet"
            >
              <h2 className="text-3xl font-bold tracking-wide text-[#b8955d]">
                Centre SpaLand
              </h2>

              <p className="text-xs uppercase tracking-[4px] text-gray-400 mt-1">
                Saphir Palace & Spa Hammamet ★★★★★
              </p>
            </Link>

            <p className="text-gray-400 leading-relaxed text-sm">
              Découvrez des soins de bien-être, de relaxation et de beauté de luxe conçus pour revitaliser votre corps et votre esprit.
            </p>

            {/* Socials */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.facebook.com/share/17YdZ4YucW/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#b8955d] transition duration-300"
              >
                <FaFacebookF />
              </a>

              <a
                href="https://www.instagram.com/spaland_yassminehammamet/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#b8955d] transition duration-300"
              >
                <FaInstagram />
              </a>

              <a
                href="https://wa.me/21697902051"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#b8955d] transition duration-300"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">
              Liens Rapides
            </h3>

            <ul className="space-y-4 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-[#b8955d] transition duration-300"
                >
                  Accueil
                </Link>
              </li>

              <li>
                <Link
                  to="/services"
                  className="text-gray-400 hover:text-[#b8955d] transition duration-300"
                >
                  Services
                </Link>
              </li>

              <li>
                <Link
                  to="/gallery"
                  className="text-gray-400 hover:text-[#b8955d] transition duration-300"
                >
                  Galerie
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-[#b8955d] transition duration-300"
                >
                  A Propos
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-[#b8955d] transition duration-300"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">
              Nos Services
            </h3>

            <ul className="space-y-4 text-sm text-gray-400">
              <li>Massage Relaxant</li>
              <li>Soins Visage</li>
              <li>Hammam Luxe</li>
              <li>Remise En Forme</li>
              <li>Sauna et Bien-être</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-white">
              Coordonnées
            </h3>

            <ul className="space-y-5 text-sm">
              <li className="flex items-start gap-3 text-gray-400">
                <FaMapMarkerAlt className="mt-1 text-[#b8955d]" />

                <span>
                 Centre Spa Land Saphir Palace & Spa
                  <br />
                  Hammamet, Tunisia
                </span>
              </li>

              <li className="flex items-center gap-3 text-gray-400">
                <FaPhoneAlt className="text-[#b8955d]" />

                <a
                  href="tel:+21697902051"
                  className="hover:text-[#b8955d] transition duration-300"
                >
                  +216 97 902 051
                </a>
              </li>

              <li className="flex items-center gap-3 text-gray-400">
                <FaEnvelope className="text-[#b8955d]" />

                <a
                  href="mailto:Fredj_bannour@yahoo.fr"
                  className="hover:text-[#b8955d] transition duration-300"
                >
                  Fredj_bannour@yahoo.fr
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
          <p>
            © {currentYear} Centre SpaLand Saphir Palace & Spa  ★★★★★. Tous droits réservés.
          </p>

          <div className="flex items-center gap-6">
            <Link
              to="/politique-confidentialite"
              className="hover:text-[#b8955d] transition duration-300"
            >
              Politique de Confidentialité
            </Link>

            <Link
              to="/conditions-generales"
              className="hover:text-[#b8955d] transition duration-300"
            >
              Conditions générales
            </Link>
            <a
  href="https://www.facebook.com/share/1EznxG7uiE/"
  target="_blank"
  rel="noopener noreferrer"
  className="hover:text-[#b8955d] transition duration-300"
>
 Powered By Khenissi WebDev
</a>
          </div>
        </div>
      </div>
    </footer>
  )
}